export default {
    data() {
        return {
            apiPrefix: window.apiBaseUrl + "api/",
            apiEndpoints: {
                //register: ['POST', 'register'],
                login: ["POST", "login"],
                logout: ["GET", "logout"],
                currentUser: ["GET", "user"],

                devices: ["GET", "device"],
                device: ["GET", "single_device"],
                myDevices: ["GET", "my_devices"],
                addDevice: ["POST", "add_device"],
                removeDevice: ["DELETE", "remove_device"],
                updateDevice: ["PUT", "device"],
                createDevice: ["POST", "device"],
                downloadAllReadings: ["GET", "download_all_readings"],
                showDeviceDownloadableRecords: [
                    "GET",
                    "show_device_downloadable_years"
                ],
                downloadDeviceReadingsByYear: [
                    "GET",
                    "download_device_readings_by_year"
                ],

                logs: ["GET", "log"],
                upload: ["POST", "log"],
                updateLog: ["PUT", "log"],
                myLogs: ["GET", "mylogs"],
                multipleDeviceLogs: ["GET", "multiple_device_logs"],

                logInfo: ["GET", "log_info"],

                getAddress: ["GET", "get_address"],
                getMapToken: ["GET", "map_token"],

                groups: ["GET", "group"],
                updateGroup: ["PUT", "group"],
                createGroup: ["POST", "group"],

                users: ["GET", "user"],
                updateUser: ["PUT", "user"],
                deleteUser: ["DELETE", "user"],
                createUser: ["POST", "register"],

                following: ["GET", "follow"],
                follow: ["POST", "follow"],
                unFollow: ["DELETE", "follow"],

                resetPassword: ["POST", "reset_password"],
                emailPassword: ["POST", "email_password"],

                createLink: ["GET", "create_link"],
                showLink: ["GET", "show_link"],

                deviceAdmin: ["GET", "device_admin"],
                deviceAdminUpdate: ["PUT", "device_admin"],
                deviceAdminDelete: ["DELETE", "device_admin"],
                deviceAdminCreate: ["POST", "device_admin"],
                deviceGroupAutocomplete: ["GET", "device_group_autocomplete"]
            },
            offlineRoutes: [
                "home",
                "offline",
                "log",
                "my_logs",
                "my_devices",
                "usbdevice",
                "usbdevicetest",
                "usbdevicestatus",
                "viewflash",
                "calibrate"
            ]
        };
    },
    methods: {
        storeToken: function(apiData) {
            //this.$store.commit('setUser', apiData);
            window.localStorage.userData = JSON.stringify(apiData);
        },
        loadToken: function() {
            //return this.$store.state.user;
            try {
                return (
                    window.localStorage.userData &&
                    JSON.parse(window.localStorage.userData)
                );
            } catch {}

            return undefined;
        },
        clearToken: function() {
            return window.localStorage.removeItem("userData");
        }
    },
    computed: {
        userData() {
            return this.loadToken();
        }
    }
};
